export default {"src":"/_next/static/media/SurgeryofBladder.1aef7011.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};